import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  headerContent: {
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: "12px",
  },
  headerConfig: {
    color: theme.color.gray5,
    fontSize: 14,
  },
  select: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
